// extracted by mini-css-extract-plugin
export var container = "JoinTeamSection-module--container--b76fd";
export var content = "JoinTeamSection-module--content--980eb";
export var founderCard = "JoinTeamSection-module--founderCard--0a6f9";
export var founderName = "JoinTeamSection-module--founderName--737b7";
export var founderRole = "JoinTeamSection-module--founderRole--61518";
export var foundersCol = "JoinTeamSection-module--foundersCol--ff2d5";
export var foundersGrid = "JoinTeamSection-module--foundersGrid--1a4f3";
export var photo = "JoinTeamSection-module--photo--64332";
export var section = "JoinTeamSection-module--section--5867f";
export var tag = "JoinTeamSection-module--tag--6d4a3";
export var text = "JoinTeamSection-module--text--e2aa3";
export var textCol = "JoinTeamSection-module--textCol--da840";
export var title = "JoinTeamSection-module--title--e0aba";